import { useState } from 'react'
import { connect } from 'react-redux'

import { recentUserSelector } from 'selectors/user'

import Lookup from './lookup'
import Internal from './internal'
import External from './external'
import NoUser from './no_user'

const getStep = (authenticationData) => {
  if (!authenticationData) {
    return 'lookup'
  } if (!authenticationData.authentication) {
    return 'no_user'
  }
  return authenticationData.authentication.type
}

const Body = ({ closePopup, recentUser }) => {
  const [authenticationData, setAuthenticationData] = useState(recentUser)

  switch (getStep(authenticationData)) {
    case 'lookup':
      return (
        <Lookup
          closePopup={closePopup}
          setAuthenticationData={setAuthenticationData}
        />
      )
    case 'internal':
      return (
        <Internal
          authenticationData={authenticationData}
          setAuthenticationData={setAuthenticationData}
          closePopup={closePopup}
        />
      )
    case 'external':
      return (
        <External
          closePopup={closePopup}
          authenticationData={authenticationData}
          setAuthenticationData={setAuthenticationData}
        />
      )
    case 'no_user':
      return (
        <NoUser
          closePopup={closePopup}
          email={authenticationData.email}
        />
      )
    default:
      return null
  }
}

const mapStateToProps = (state) => ({
  recentUser: recentUserSelector(state)
})

export default connect(mapStateToProps)(Body)
